import { formatTime, isSameDay, toDateKey } from "../../utils/date";
import { cx } from "../../utils/classNames";
import {
  formatRecordHours,
  getStatusForDate,
  STATUS_LABELS,
} from "./attendanceStatus";
import AwayPin from "./AwayPin";
import { DayFlags } from "./components/DayFlags";
import DayMapLink from "./components/DayMapLink";
import { hasApprovedOvertime } from "../overtime/overtimeUtils";
import styles from "./AttendanceView.module.css";

const AttendanceListView = ({ days, recordsByDate }) => {
  const today = new Date();

  if (!days.length) {
    return (
      <div className={styles.empty}>
        <i className="bi bi-calendar-x"></i>
        <div>No attendance data for this month.</div>
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Date</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th>Hours</th>
            <th>Status</th>
            <th className="text-center">Overtime</th>
            <th>Check-ins</th>
          </tr>
        </thead>

        <tbody>
          {days.map((date) => {
            const key = toDateKey(date);
            const record = recordsByDate[key];
            const status = getStatusForDate(date, recordsByDate);

            return (
              <tr
                key={key}
                className={cx(isSameDay(date, today) && styles.isToday)}
              >
                <td>
                  {date.getDate()}{" "}
                  <span className={styles.dayName}>
                    {date.toLocaleDateString("en-PH", { weekday: "short" })}
                  </span>
                </td>
                <td>
                  {formatTime(record?.checkInTime)}
                  {record?.checkInOutsideBranch === true && <AwayPin />}
                  <DayMapLink record={record} kind="in" />
                </td>
                <td>
                  {formatTime(record?.checkOutTime)}
                  {record?.checkOutOutsideBranch === true && <AwayPin />}
                  <DayMapLink record={record} kind="out" />
                </td>
                <td>{formatRecordHours(record)}</td>
                <td>
                  <span className={cx(styles.statusPill, styles[status])}>
                    <span className={styles.statusDot}></span>
                    {STATUS_LABELS[status]}
                  </span>
                </td>
                <td className="text-center">
                  {/* Read-only: ticked once an overtime request for the day is approved. */}
                  {record && (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={hasApprovedOvertime(record)}
                      readOnly
                      tabIndex={-1}
                      title={
                        hasApprovedOvertime(record)
                          ? `Approved overtime${record.overtimeHours > 0 ? `: ${formatRecordHours({ workHours: record.overtimeHours })}` : ""}`
                          : "No approved overtime"
                      }
                      aria-label={
                        hasApprovedOvertime(record)
                          ? "Approved overtime"
                          : "No approved overtime"
                      }
                      style={{ pointerEvents: "none" }}
                    />
                  )}
                </td>
                <td>
                  <DayFlags record={record} showOvertime={false} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceListView;
